import { useContext } from "react";
import { bool, node, number, arrayOf, shape, string } from "prop-types";
import { EstimateTableSettingsContext } from "./EstimateTableSettingsContext";

export const useEstimateTableSettings = () => {
  const context = useContext(EstimateTableSettingsContext);
  if (context === null) {
    throw new Error("EstimateTableSettings cannot be null, please add a context provider");
  }
  return context;
};

export const EstimateTableSettingsProvider = ({ children, ...value }) => (
  <EstimateTableSettingsContext.Provider value={value}>
    {children}
  </EstimateTableSettingsContext.Provider>
)

EstimateTableSettingsProvider.propTypes = {
  children: node.isRequired,
  useExpandCell: bool,
  columns: arrayOf(shape({
    name: string.isRequired,
    visible: bool,
  })),
  timelineLength: number,
  descriptionVisible: bool,
  visibleWorkTypes: arrayOf(shape({
    id: number,
    invisible: bool,
  })),
  maxTitleCellWidth: number,
  sectionContainerWidth: number,
  // priceClassName: string,
  // descriptionClassName: string,
  // labelsClassName: string,
  showCombinedHours: bool,
  materialsSection: bool,
  emptyWorkTypeCells: number,
  // emptyMaterialCells: number,
  totalEstimateCells: number,
}
